'use strict';

var StripeService = ($window) => ({
  createToken(data, callback) {
    $window.Stripe.card.createToken(
      {
        number: data.number,
        cvc: data.cvc,
        exp_month: data.expiry.split('/')[0],
        exp_year: data.expiry.split('/')[1],
      },
      callback
    );
  },
});

angular.module('cdPay.providers').factory('StripeService', StripeService);
